import { Calendar } from 'assets/icons';
import Divider from 'components/divider/divider';
import { enGB, fr } from 'date-fns/locale';
import { useRef } from 'react';
import DatePicker, { registerLocale } from 'react-datepicker';

registerLocale('en-GB', enGB);
registerLocale('fr-FR', fr);

const PlanningDateSection = ({
  dataCreateMission,
  handleDateStart,
  handleDateEnd,
  error1,
  error,
}) => {
  const endDatePickerRef = useRef(null);
  const onStartChange = (date) => {
    handleDateStart(date);
    if (
      endDatePickerRef.current &&
      (!dataCreateMission.dateEnd || dataCreateMission.dateEnd < date)
    ) {
      endDatePickerRef.current.setOpen(true);
    }
  };
  return (
    <div className="flex flex-col gap-4">
      <div className="text-xl">Période</div>
      <div className="flex gap-4">
        <div className="w-full">
          <label
            htmlFor="dateStart"
            className="block ft-sm font-medium text-gray-500"
          >
            Date de début
          </label>
          <div className="relative">
            <DatePicker
              dateFormat="dd/MM/yyyy"
              selected={dataCreateMission.dateStart}
              onChange={onStartChange}
              locale="fr-FR"
              peekNextMonth
              showMonthDropdown
              showYearDropdown
              disabledKeyboardNavigation
              dropdownMode="select"
              popperPlacement="bottom"
              className="w-full h-10 pl-8 pr-8 ft-b border rounded-lg cursor-pointer"
            />
            <div className="absolute inset-y-0 left-0 flex items-center px-2 pointer-events-none">
              <Calendar wh={18} color="#666666" strokeW={2} />
            </div>
          </div>
          {error1 && (
            <span className="ft-sm text-red-500">
              Veuillez indiquer une date valide
            </span>
          )}
        </div>
        <div className="w-full">
          <label
            htmlFor="dateEnd"
            className="block ft-sm font-medium text-gray-500"
          >
            Date de Fin
          </label>
          <div className="relative">
            <DatePicker
              ref={endDatePickerRef}
              dateFormat="dd/MM/yyyy"
              selected={dataCreateMission.dateEnd}
              onChange={handleDateEnd}
              locale="fr-FR"
              peekNextMonth
              showMonthDropdown
              showYearDropdown
              disabledKeyboardNavigation
              dropdownMode="select"
              popperPlacement="bottom"
              className="w-full h-10 pl-8 pr-8 ft-b border rounded-lg cursor-pointer"
            />
            <div className="absolute inset-y-0 left-0 flex items-center px-2 pointer-events-none">
              <Calendar wh={18} color="#666666" strokeW={2} />
            </div>
          </div>
          {error && (
            <span className="ft-sm text-red-500">
              Veuillez indiquer une date valide
            </span>
          )}
        </div>
      </div>
      <Divider />
    </div>
  );
};

export default PlanningDateSection;
